import type { ReactNode } from 'react';
import _ from 'lodash';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import PageBreadcrumb from '@/components/PageBreadcrumb';
import usePathname from '@fuse/hooks/usePathname';
import BillingAppNavigation from './BillingAppNavigation';

type BillingAppHeaderProps = {
	className?: string;
	onSetSidebarOpen: (open: boolean) => void;
	/** Optional right-side action (e.g. Payment Method “Add New Card”) */
	headerAction?: ReactNode;
};

function BillingAppHeader(props: BillingAppHeaderProps) {
	const { className, onSetSidebarOpen: _onSetSidebarOpen, headerAction } = props;
	const pathname = usePathname();
	const currentNavigation = _.find(BillingAppNavigation.children, { url: pathname });

	return (
		<div
			className={clsx(
				'flex w-full flex-col gap-4 sm:flex-row sm:items-end sm:justify-between sm:gap-6',
				className
			)}
		>
			<div className="min-w-0 flex-1">
				<div className="flex items-center gap-3">
					<PageBreadcrumb className="mb-2" />
				</div>

				<Typography className="mt-4 text-3xl font-bold leading-none tracking-tight text-left sm:mt-0 lg:ml-0">
					{currentNavigation?.title}
				</Typography>
			</div>
			{headerAction ? <div className="flex shrink-0 items-center">{headerAction}</div> : null}
		</div>
	);
}

export default BillingAppHeader;
